const STEP_KEYS = {
  leads: "leads",
  students: "students",
  visaApplicants: "visaApplicants",
  skillAssessments: "skillAssessments",
  insuranceApplicants: "insuranceApplicants",
  tribunalReviews: "tribunalReviews",
};

const STEP_MAPPER = {
  lead: 0,
  education: 1,
  visa: 2,
  skill_assessment: 3,
  health_insurance: 4,
  tribunal_review: 5,
};

const STUDENT_STEPS = [
  {
    id: STEP_MAPPER.lead,
    label: "Lead",
    name: "lead",
    key: STEP_KEYS.leads,
  },
  {
    id: STEP_MAPPER.education,
    label: "Education",
    name: "education",
    key: STEP_KEYS.students,
  },
  {
    id: STEP_MAPPER.visa,
    label: "Visa",
    name: "visa",
    key: STEP_KEYS.visaApplicants,
  },
  {
    id: STEP_MAPPER.skill_assessment,
    label: "Skill Assessment",
    name: "skill_assessment",
    key: STEP_KEYS.skillAssessments,
  },
  {
    id: STEP_MAPPER.health_insurance,
    label: "Health Insurance",
    name: "health_insurance",
    key: STEP_KEYS.insuranceApplicants,
  },
  {
    id: STEP_MAPPER.tribunal_review,
    label: "Tribunal Review",
    name: "tribunal_review",
    key: STEP_KEYS.tribunalReviews,
  },
];

export { STEP_MAPPER, STUDENT_STEPS, STEP_KEYS };
